<template>
  <div class="exchange-flow-select">
    <ExchangeFlowItem
      v-for="item in list"
      :key="item.value"
      :active="item.value === props.value"
      @click="handleFlowToggle(item.value)"
    >
      {{ item.label }}
    </ExchangeFlowItem>
  </div>
</template>

<script lang="ts" setup>
import { i18n } from '@/i18n';
import { Flow } from '@/types';
import { computed } from 'vue';

import ExchangeFlowItem from './ExchangeFlowItem.vue';

interface Options {
  label: string;
  value: Flow;
}

const props = defineProps<{
  value: Flow,
  isCorporateAccount: boolean,
  isUkUser: boolean,
}>();

const emit = defineEmits<{
  (e: 'input', value: string): void,
}>();

const showSwapCryptoOption = computed(() => {
  return !props.isUkUser;
});

const list = computed<Options[]>(() => {
  const result = [
    {
      label: i18n.t('exchange-form.flow.buy-crypto').toString(),
      value: Flow.FIAT_TO_CRYPTO,
    },
    {
      label: i18n.t('exchange-form.flow.sell-crypto').toString(),
      value: Flow.CRYPTO_TO_FIAT,
    },
  ];

  if (showSwapCryptoOption.value) {
    result.push({
      label: i18n.t('exchange-form.flow.swap-crypto').toString(),
      value: Flow.CRYPTO_TO_CRYPTO,
    });
  }

  return result;
});

const handleFlowToggle = (flow: Flow) => {
  if (props.value === flow) {
    return;
  }

  emit('input', flow);
};
</script>

<style lang="scss" scoped>
@import "@scss-vars";

.exchange-flow-select {
  display: flex;
  gap: 4px;
  white-space: nowrap;
  flex-wrap: wrap;
  justify-content: center;

  @media screen and (max-width: $screen-lg-min) {
    gap: 4px 24px;
  }
}
</style>
